import { ReactNode } from 'react';

export interface ErrorDisplayProps {
  title?: ReactNode;
  message?: ReactNode;
  actions?: ReactNode;
}

export const ErrorDisplay = ({ title, message, actions }: ErrorDisplayProps) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      {title && <h1 className="text-2xl font-semibold">{title}</h1>}
      {message && <p className="text-muted-foreground">{message}</p>}
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
};
